import { render, staticRenderFns } from "./AddServiceCategoryModal.vue?vue&type=template&id=b05eba1c&"
import script from "./AddServiceCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddServiceCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports